import { useState, useEffect, useRef } from 'react';

export const useSidebar = () => {
    const [user, setUser] = useState(null);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [expandedSections, setExpandedSections] = useState({
        dashboards: true,
        croManagement: true,
        settings: true,
        applications: true,
        sponsor: true,
        piDoctors: true,
        reports: true
    });
    const userMenuRef = useRef(null);

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            const parsedUser = JSON.parse(userData);
            setUser(parsedUser);
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleSection = (sectionName) => {
        setExpandedSections(prev => ({
            ...prev,
            [sectionName]: !prev[sectionName]
        }));
    };

    return {
        user,
        showUserMenu,
        setShowUserMenu,
        expandedSections,
        toggleSection,
        userMenuRef
    };
};